import { fabric } from 'fabric';
fabric.filterBackend = fabric.initFilterBackend();
fabric.filterBackend = new fabric.Canvas2dFilterBackend();
fabric.Object.prototype.padding = 5;
fabric.Object.prototype.transparentCorners = false;
fabric.Object.prototype.transparentCorners = false;
fabric.Object.prototype.cornerColor = '#8296fe';
fabric.Object.prototype.cornerStyle = 'circle';
fabric.Object.prototype.objectCaching = false;
fabric.Object.prototype.cornerStrokeColor = '#FFFFFF';
fabric.Object.prototype.borderColor = '#FFFFFF';
fabric.Object.prototype.padding = 5;
export default fabric;
